module.exports = __webpack_public_path__ + "img/alertbutton.88f2c5ff.png";